export const IMAGE_WIDTH_THUMBNAIL = 24;

export const IMAGE_WIDTH_S = 130;
export const IMAGE_WIDTH_M = 204;
export const IMAGE_WIDTH_XL = 292;
export const IMAGE_WIDTH = [IMAGE_WIDTH_S, IMAGE_WIDTH_M, IMAGE_WIDTH_M, IMAGE_WIDTH_XL];

export const SWIPE_THRESHOLD = 50;

const SLIDE_WIDTH_S = 154;
const SLIDE_WIDTH_M = 181;
const SLIDE_WIDTH_L = 204;
const SLIDE_WIDTH_XL = 234;

export const SLIDE_WIDTH = [SLIDE_WIDTH_S, SLIDE_WIDTH_M, SLIDE_WIDTH_L, SLIDE_WIDTH_XL];

const SMALL_SLIDE_WIDTH_L = 153;
const SMALL_SLIDE_WIDTH_XL = 176;

export const SMALL_SLIDE_WIDTH = [
  SLIDE_WIDTH_S,
  SLIDE_WIDTH_M,
  SMALL_SLIDE_WIDTH_L,
  SMALL_SLIDE_WIDTH_XL,
];
